var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { VErrorIcon, Flex, Icon, Box } from '@springcare/sh-component-library';
export var PaymentAlert = function (_a) {
    var children = _a.children, _b = _a.testId, testId = _b === void 0 ? 'invoice-alert' : _b, _c = _a.icon, icon = _c === void 0 ? VErrorIcon : _c, styles = __rest(_a, ["children", "testId", "icon"]);
    return (_jsxs(Flex, __assign({ "data-testid": testId, alignItems: "center", height: "fit-content", minH: "74px", borderRadius: "16px", gap: "3", py: "2", px: "3", sx: {
            WebkitPrintColorAdjust: 'exact',
            printColorAdjust: 'exact',
        } }, styles, { children: [_jsx(Flex, __assign({ alignItems: "center" }, { children: _jsx(Icon, { as: icon, boxSize: 4 }) })), _jsx(Box, { children: children })] })));
};
